import "./index.css";
import { useEffect, useState } from "react";
import EmptyState from "../empty-state";
import ScannedSite from "../scanned-site";
import LoadingState from "../loading-state";

function ScanFeedHolder({ feedItems, handleClick, isLoaded, openSiteAdder }) {
  const [renderedFeedItems, setRenderedFeedItems] = useState([]);

  useEffect(() => {
    setRenderedFeedItems(feedItems || []);
  }, [feedItems]);

  if (!isLoaded) return <LoadingState />;

  if (!renderedFeedItems || renderedFeedItems.length === 0) {
    return (
      <EmptyState message="No sites added yet..." openSiteAdder={openSiteAdder} />
    );
  }

  return (
    <div className="feed-holder">
      {renderedFeedItems.map((item, index) => (
        <ScannedSite
          key={`${item.domain || "site"}-${index}`}
          domain={item.domain}
          status={item.status}
          handleClick={handleClick}
          dateAddedByUser={item.dateAddedByUser}
        />
      ))}
    </div>
  );
}

export default ScanFeedHolder;